var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareGroupIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.1,
    viewBox: "0 0 18 18.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share_Group_18px",
    "data-name": "Share Group_18px",
    transform: "translate(-672 -928)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_862",
    "data-name": "Rectangle 862",
    width: 18,
    height: 18,
    transform: "translate(672 928)",
    fill: "none",
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("g", {
    id: "Share_Group_18px-01",
    "data-name": "Share Group_18px-01",
    transform: "translate(672.05 928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M9,4.4A2.375,2.375,0,0,0,6.6,6.1c0,.2,0,.2.2.2h4.4a.215.215,0,0,0,.2-.2A2.27,2.27,0,0,0,9,4.4H9Z",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M3,10A2.375,2.375,0,0,0,.6,11.7c0,.2,0,.2.2.2H5.2a.215.215,0,0,0,.2-.2A2.27,2.27,0,0,0,3,10H3Z",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M14.9,10a2.375,2.375,0,0,0-2.4,1.7c0,.2,0,.2.2.2h4.4a.215.215,0,0,0,.2-.2A2.27,2.27,0,0,0,14.9,10h0Z",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M9,15.6a2.375,2.375,0,0,0-2.4,1.7c0,.2,0,.2.2.2h4.4a.215.215,0,0,0,.2-.2A2.27,2.27,0,0,0,9,15.6H9Z",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M6.8,14.7a5.957,5.957,0,0,1-2.1-1.4",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M13.5,13.4a5.328,5.328,0,0,1-2,1.3",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M11.1,3.2a5.8,5.8,0,0,1,2.7,1.9",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M4.3,5.1a6.292,6.292,0,0,1,2.8-2",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 1.1,
    cy: 1.2,
    rx: 1.1,
    ry: 1.2,
    transform: "translate(8 0.5)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_128",
    "data-name": "Ellipse 128",
    cx: 1.1,
    cy: 1.2,
    rx: 1.1,
    ry: 1.2,
    transform: "translate(13.8 6.1)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    cx: 1.1,
    cy: 1.2,
    rx: 1.1,
    ry: 1.2,
    transform: "translate(1.9 6.1)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    cx: 1.1,
    cy: 1.2,
    rx: 1.1,
    ry: 1.2,
    transform: "translate(7.9 11.7)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareGroupIcon);
export default __webpack_public_path__ + "static/media/share-group-icon.f2e5aa070e89be8b8c754229a2033c33.svg";
export { ForwardRef as ReactComponent };